import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import ThemeContext from '../../providers/ThemeProvider';

const ViewMore = ({ navigations, title }) => {
  const theme = useContext(ThemeContext);

  return (
    <div className="container">
      <h3>View more {title}</h3>
      <ul className="viewmore-container">
        {navigations.map((item) => (
          <a href={item.url} key={item.id}>
            {item.linkText}
          </a>
        ))}
      </ul>

      <style jsx>{`
        .container {
          text-align: center;
        }
        .container h3 {
          font-size: 20px;
        }
        .viewmore-container {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          padding: 10px;
        }
        .viewmore-container a {
          color: ${theme.colors.breadcrumbhover};
          display: block;
          font-weight: bold;
          padding: 10px;
          text-align: center;
          text-decoration: none;
          width: 25%;
        }
        .viewmore-container a:hover {
          color: #333;
        }
      `}</style>
    </div>
  );
};

export default ViewMore;

ViewMore.propTypes = {
  navigations: PropTypes.array,
  title: PropTypes.string,
};
